// Mirrors Agentic::Prompt::CATEGORIES in irwin-api. Keep in sync if the
// backend list changes — we mirror it client-side rather than fetching to
// avoid an extra request on the form page.
export const AGENTIC_PROMPT_CATEGORIES = [
  'email',
  'general',
  'holders',
  'iq',
  'irm',
  'profiles',
  'pulse',
  'reports',
  'suggested',
  'targeting',
]

export const AGENTIC_PROMPT_SCOPES = {
  PARENTS: 'parents',
  CHILDREN: 'children',
  ALL: 'all',
}

export const AGENTIC_PROMPT_STATUSES = ['internal', 'general']
